/**
 * @fileoverview Input/output schemas for world-system-details-ideation-v3.
 *
 * This agent generates creative directions for developing a world system's details.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.activeWorldSystem.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

export const WorldSystemDetailsIdeaSchema = z.object({
  title: z.string().describe('A short, evocative title for this creative direction.'),
  summary: z.string().describe("A detailed summary of the system's mechanics, limitations, consequences, and narrative implications."),
});

export type WorldSystemDetailsIdea = z.infer<typeof WorldSystemDetailsIdeaSchema>;

export const OutputSchema = z.object({
  ideas: z.array(WorldSystemDetailsIdeaSchema).length(3).describe('An array of exactly three distinct system detail concepts.'),
});

export type Output = z.infer<typeof OutputSchema>;
